import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-38c42075")

_pushScopeId("data-v-38c42075")
const _hoisted_1 = { class: "phone-verification-module" }
const _hoisted_2 = { class: "phone-verification-content" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "phone" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "prefix" }, "+86", -1)
const _hoisted_6 = { class: "verification-code" }
const _hoisted_7 = { class: "footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AccountManageHeader = _resolveComponent("AccountManageHeader")!
  const _component_VerificationHeader = _resolveComponent("VerificationHeader")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_AccountManageHeader, { onClose: _ctx.closeModal }, null, 8, ["onClose"]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_VerificationHeader),
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.phone = $event)),
            placeholder: "请输入手机号"
          }, null, 512), [
            [_vModelText, _ctx.phone]
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _withDirectives(_createVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.verificationCode = $event)),
            placeholder: "请输入验证码"
          }, null, 512), [
            [_vModelText, _ctx.verificationCode]
          ]),
          _createVNode("div", {
            class: ["btn", { disabled: _ctx.countdown > 0 }],
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.sendVerificationCode && _ctx.sendVerificationCode(...args)))
          }, _toDisplayString(_ctx.countdown > 0 ? `${_ctx.countdown}秒后重试` : '发送验证码'), 3)
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("button", {
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, "取消"),
        _createVNode("button", {
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
        }, "确定")
      ])
    ])
  ]))
})